import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import {ExportToExcel} from "../ExportToExcel.jsx";
import {CopyDataToClipboard} from "../CopyDataToClipboard.jsx";
import {useSelector} from "react-redux";
import TooltipInfo from "../TooltipInfo.jsx";

export const StackedBarChartAnaliza = ({
                                           data,
                                           dataKeys,
                                           xDatakey,
                                           title,
                                           selectors,
                                           hideExelExport = false,
                                           hideCopyToclipboard = false,
                                           tooltipKey,
                                       }) => {

    // const getRandomColor = () =>
    //     "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
    //
    // const dataKeys = useMemo(() => {
    //     if (!data.length) return [];
    //     return Object.keys(data[0]).filter(
    //         (key) => key !== "nr_cyklu"
    //     );
    // }, []);
    //
    // const colors = useMemo(() => {
    //     const colorMap = {};
    //     dataKeys.forEach((key) => {
    //         colorMap[key] = getRandomColor();
    //     });
    //     return colorMap;
    // }, [dataKeys]);

    const tooltipHtml = useSelector(state =>
        state.chartTooltips.msg[tooltipKey]?.value
    );

    return (
        <Card>
            <Card.Header>
                <div className={'d-flex justify-content-between gap-3'}>
                    <div className={'d-flex justify-content-between'}>
                        <div className={'fs-5'}>
                            {title ?? 'Analiza'}
                        </div>
                        <div>
                            {tooltipHtml && (
                                <TooltipInfo text={tooltipHtml} className="ms-2" />
                            )}
                        </div>
                    </div>
                    <div>
                        {!!selectors && selectors()}
                    </div>
                    <div>
                        {(!hideExelExport && data) &&
                            <ExportToExcel
                                data={data}
                                fileName={title || 'analiza'}
                            />
                        }
                        {(!hideCopyToclipboard && data) &&
                            <CopyDataToClipboard data={data}/>
                        }
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={data}>
                        <Tooltip/>
                        <YAxis/>
                        <XAxis dataKey={xDatakey}/>
                        <Legend/>
                        <CartesianGrid strokeDasharray="3 3"/>
                        {
                            // dataKeys.map((dataKey, idx) => (
                            //     <Bar key={idx} stackId={'cykl'} dataKey={dataKey} fill={colors[dataKey]}/>
                            // ))
                            dataKeys.map((dataKey, idx) => (
                                <Bar key={idx} stackId={'cykl'} dataKey={dataKey.dataKey} fill={dataKey.color}/>
                            ))
                        }
                    </BarChart>
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    )
}

StackedBarChartAnaliza.propTypes = {
    data: PropTypes.array.isRequired,
    dataKeys: PropTypes.array.isRequired,
    xDatakey: PropTypes.string.isRequired,
    yDatakey: PropTypes.string.isRequired,
    fill: PropTypes.string,
    title: PropTypes.string,
    colors: PropTypes.array,
    selectors: PropTypes.func,
    hideExelExport: PropTypes.bool,
    hideCopyToclipboard: PropTypes.bool,
    tooltipKey: PropTypes.string,
}
